import { Component, OnInit } from '@angular/core';
import { ABCisTableModel, ColumnType } from 'src/app/components/abcis-table/abcis-table.component';
import { ABCisApi } from 'src/app/handlers/apiHandler.service';

@Component({
  selector: 'app-default-store-type-settings-config',
  standalone: false,
  templateUrl: './default-store-type-settings-config.component.html',
  styleUrls: ['./default-store-type-settings-config.component.scss']
})
export class DefaultStoreTypeSettingsConfigComponent implements OnInit {

  tableConfig: ABCisTableModel;

  constructor() { }

  ngOnInit() {
    this.SetTableConfig();
  }

  SetTableConfig() {
    this.tableConfig = {
      apiConfig: {
        api: ABCisApi.Support,
        table: 'null',
        url: 'default-store-type-settings',
        approxamateRowCount: 1000,
        anyParams: true
      },
      colConfig: [
        { field: 'storeId', header: 'Store ID', type: ColumnType.MultiSelectComplex, setUrl: 'store/lookup' , isReadonly: true, isPrimary: true },
        { field: 'documentTypeCode', header: 'Document Type Code', type: ColumnType.DropDown, setUrl: 'document-type/lookup'},
        { field: 'defaultOrderFlag', header: 'Default Order Flag', type: ColumnType.DropDown, setUrl: 'order-flag/lookup', addFormDefault: 'U' },
        { field: 'isPurchaseOrderNumberRequired', header: 'Is Purchase Order Number Required?', type: ColumnType.Boolean, addFormDefault: false},
        { field: 'isDocumentDiscarded', header: 'Is Document Discarded?', type: ColumnType.Boolean, addFormDefault: false},
        { field: 'isAutocompleteAllowed', header: 'Is Autocomplete Allowed?', type: ColumnType.Boolean, addFormDefault: true}
      ],
      addFormConfig: {
        header: 'Add Default Store Type Settings'
      },
      isConfigurable: true,
      canEdit: true
    };
  }
}
